const config = {
  alertMessage: process.env.REACT_APP_ALERT_MESSAGE || ''
}

export default config
